export default __webpack_public_path__ + "static/Answer, summarise, prioritise-749860be940dd02043417f1b7bf5494b.png";